<template>
  <div class="upload-box">
    <el-upload ref="uploaderImage" class="uploader-image" action="" accept="image/*" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false">
      <div v-if="url" style="width: 100%;height: 100%;">
        <img :src="url" class="uploader-img" title="替换图片">
      </div>
      <i v-else class="el-icon-plus plus-push" />
    </el-upload>
    <div class="tips">支持上传*.png、*.jpg，大小不超过{{ limitSize }}M，尺寸：{{ sizeTips }}</div>
  </div>
</template>

<script>
import { getFileType } from '@/common/js/util';

export default {
  name: 'UpdateImage',
  props: {
    url: {
      type: String,
      default: '',
    },

    sizeTips: {
      type: String,
      default: '',
    },
    limitSize: {
      type: Number,
      default: 5,
    },
    savePath: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handlePushUploader(file) {
      this.uploader(file);
    },
    uploader(file) {
      if (getFileType(file.raw.name) !== 'image') {
        this.$message.error('图片格式不正确');
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      if (this.limitSize && parseFloat(file.raw.size / 1024 / 1024) > this.limitSize) {
        this.$message.error(`图片大小不能超过${this.limitSize}M`);
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      this.sizeTips ? this.asyncImgChecked(file).then(data => {
        if (data) {
          this.$Api.uploadFile.uploadImage(file.raw, this.savePath).then(data => {
            this.uploadLoading = false;
            this.$emit('upload', data);
            this.$emit('triggerReg', file);
          });
        } else {
          return;
        }
      }) : this.$Api.uploadFile.uploadImage(file.raw, this.savePath).then(data => {
        this.uploadLoading = false;
        this.$emit('upload', data);
        this.$emit('triggerReg', file);
      });
    },
    asyncImgChecked(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw); // 必须用file.raw
        reader.onload = () => { // 让页面中的img标签的src指向读取的路径
          const img = new Image();
          img.src = reader.result;
          const width = this.sizeTips.split('*')[0];
          const height = this.sizeTips.split('*')[1];
          img.onload = () => {
            if (img.width !== parseInt(width) || img.height !== parseInt(height)) {
              this.$message.warning(`图片大小不匹配，当前文件${img.width}×${img.height}`);
              resolve(false);
            } else {
              resolve(true);
            }
          };
        };
      });
    },
  },
};
</script>

<style lang="less" >
.upload-box {
  .uploader-image {
    width: 210px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px dashed #e3e3e5;
    .el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .uploader-img {
        width: 100%;
        height: 100%;
      }
    }
    &:hover {
      border-color: #000000;
    }

    .el-icon-plus.plus-push {
      font-size: 42px;
      color: #bbbbbb;
    }
  }
  .tips {
    margin-top: 5px;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #bbbbbb;
  }
}
</style>
